import { Component, OnInit, OnDestroy } from '@angular/core';
import { ConfigService } from '../../shared/services/config.service';
import { LoggedService } from '../../shared/services/logged.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { SnackbarService } from '../../shared/services/snackbar.service';
import { Subscription } from 'rxjs';
import { UsuariosService } from '../../shared/services/usuarios.service';

@Component({
    templateUrl: 'confirmar-email.component.html'
})

export class ConfirmarEmailComponent implements OnInit, OnDestroy {

    private subscription: Subscription;

    constructor(
        private activeRoute: ActivatedRoute,
        private configService: ConfigService,
        private router: Router,
        private snackBarService: SnackbarService,
        private usuariosService: UsuariosService,
        private loggedService: LoggedService
    ) { }

    ngOnInit() {

        this.subscription = this.activeRoute.params
            .subscribe(params => {

                this.usuariosService
                    .confirmEmail({ Id: params['id'], Code: params['code'] })
                    .subscribe(
                        data => {
                            //this.snackBarService.openSnackbar(this.configService.mensajes.TituloSuccess, this.configService.mensajes.LoginUsuario.ConfirmacionContraseña);
                            localStorage.setItem('logoutLogs', JSON.stringify(
                            {
                                timestamp: new Date(),
                                reasonId: 0,
                                source: 'confirmar-email.component.ts'
                            }
                            ));
                            
                            this.loggedService.logOut(0);
                        });
            });

    }

    ngOnDestroy() {

        this.subscription.unsubscribe();

    }

}
